export const getLocaleFromNavigator = () => window.navigator.language;
